import constant from '@/constant'

export default {
  data () {
    return {
      slot: constant.ADS.slotInArticle,
      slotInFeed: constant.ADS.slotInFeed,
      client: constant.ADS.client,
      layout: constant.ADS.layout
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js